import * as AbsintheSocket from "@absinthe/socket";
import { createAbsintheSocketLink } from "@absinthe/socket-apollo-link";
import { Socket as PhoenixSocket } from "phoenix";

const createLink = (auth) => {
  const socket = new PhoenixSocket("/api/admin/socket", {
    params: { token: auth },
  });
  const absintheSocket = AbsintheSocket.create(socket);
  const link = createAbsintheSocketLink(absintheSocket);
  return link;
};

export default createLink;
